export const LATEST_HISTORY = 5;

/** Offset for sticky history table headers below the primary app bar (px). */
export const HISTORY_TABLE_STICKY_TOP = 64;

/** Sticky offset when the report navigation sub-header is visible (px). */
export const HISTORY_TABLE_STICKY_TOP_WITH_REPORT_NAV = 112;

/** Fixed height for history table header rows (px). */
export const HISTORY_TABLE_HEADER_HEIGHT = 72;

export const BMI_MIN_VALUE = 19;
export const BMI_MAX_VALUE = 25;
